// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import TagNumberSvg from '@rsuite/icon-font/lib/application/TagNumber';
var TagNumber = createSvgIcon({
  as: TagNumberSvg,
  ariaLabel: 'tag number',
  category: 'application',
  displayName: 'TagNumber'
});
export default TagNumber;